import styled from "styled-components"

export const ThumbnailsExcerpt = styled.p`
    margin-bottom: 0;
    color: var(--blogPostDate);
    
    @media (max-width: 768px) {
        display: none;
    }
`;